@if (user(); as u) {
  <div class="um-header">
    <span class="um-avatar" aria-hidden="true">{{ initials() }}</span>
    <div class="um-identity">
      <span class="um-name">{{ u.firstName }} {{ u.lastName }}</span>
      @if (u.email) {
        <span class="um-meta">{{ u.email }}</span>
      }
      <span class="um-meta">{{ u.roleDisplayName }}</span>
    </div>
  </div>
}

<div class="um-section" role="group" aria-labelledby="um-preferences">
  <span id="um-preferences" class="um-section-label">Preferences</span>
  <div class="um-pref">
    <span id="um-appearance" class="um-pref-label">Appearance</span>
    <p-selectbutton
      [options]="colorSchemeOptions"
      [ngModel]="colorScheme()"
      (ngModelChange)="setColorScheme($event)"
      optionLabel="label"
      optionValue="value"
      [allowEmpty]="false"
      size="small"
      ariaLabelledBy="um-appearance">
      <ng-template #item let-option>
        <i [class]="option.icon" aria-hidden="true"></i>
        <span>{{ option.label }}</span>
      </ng-template>
    </p-selectbutton>
  </div>
  <div class="um-pref">
    <span id="um-open-in" class="um-pref-label">Open loads in</span>
    <p-selectbutton
      [options]="openInOptions"
      [ngModel]="preferences.openLoadsIn()"
      (ngModelChange)="setOpenLoadsIn($event)"
      optionLabel="label"
      optionValue="value"
      [allowEmpty]="false"
      size="small"
      ariaLabelledBy="um-open-in" />
  </div>
  <p class="um-hint">{{ newTabShortcut }} or middle-click a load number to open it in a new browser tab any time.</p>
</div>

<button type="button" class="um-signout" (click)="signOut()">
  <i class="pi pi-power-off" aria-hidden="true"></i>
  <span>Sign out</span>
</button>
